import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateMenuScreenEntity } from '../../domain/entities/CreateUpdateMenuScreenEntity'

export class CreateUpdateMenuScreenModel extends CreateUpdateMenuScreenEntity {
  constructor(dataDto: CreateUpdateMenuScreenEntity) {
    super()
    mapEntityProperties<CreateUpdateMenuScreenModel>(this, dataDto)
  }
}
